/* eslint-disable max-len */
import React from 'react';

function ErrorBlock({ validationResult }) {
    return (
        <div className="border-2 border-[#6E1417] rounded-md bg-[#FFF5E2] h-auto p-3 my-4">
            <p className="font-semibold text-base text-[#090406] pb-3.5">Error Message</p>
            <ul className="list-disc p-4">
                {Object.entries(validationResult).map(([key, value]) => (
                    <li className="text-sm font-normal text-[#090406]">
                        {key}
                        {' '}
                        :
                        {' '}
                        {value.result}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default ErrorBlock;
